import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingStatistic = (params) => get('/api/v1/statistic/paging',params)
export const detailStatistic = (query)=>getOne(`/api/v1/statistic/detail/${query}`)
export const updateStatistic = (body)=>put(`/api/v1/statistic/update`,body)
export const createStatistic = (body)=>post(`/api/v1/statistic/create`,body)
export const deleteStatistic = (body) => destroy(`/api/v1/statistic/delete`,body)